import { render, staticRenderFns } from "./PJPartnersShareholders.vue?vue&type=template&id=8d0150a2"
import script from "./PJPartnersShareholders.vue?vue&type=script&lang=js"
export * from "./PJPartnersShareholders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports